import React, { Component } from 'react'
import _ from 'lodash';

import Icon from "@material-ui/core/Icon";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import style from "./DXFormStyles";

import DXFormInput from "./DXFormInput";
import DXFormInputDate from "./DXFormInputDate";
import DXFormInputSelection from "./DXFormInputSelection";
import DXFormInputLikert from './DXFormInputLikert';
import DXFormInputCheckbox from "./DXFormInputCheckbox";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Popover from '@material-ui/core/Popover';
import DXFormFileUploader from './DXFormFileUploader';

export default class DXFormSection extends Component {


  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    }
  }

  renderQuestion = (pid, question) => {
    const { type } = question;

    switch (type) {
      case 'input':
        return this.renderInput({ pid, question });
      case 'text':
        return this.renderInput({ pid, question, multiline: true });
      case 'number':
        return this.renderInput({ pid, question });
      case 'selection':
        return this.renderSelection({ pid, question });
      case 'checkbox':
        return this.renderCheckbox({ pid, question });
      case 'date':
        return this.renderDate({ pid, question });
      case 'likert':
        return this.renderLikert({ pid, question });
      case 'file':
        return this.renderFileUploader({ pid, question });
      default:
      // do nothing
    }
  }

  renderInput = (params) => {
    const { valueState, classes } = this.props;
    const { pid, question } = params;

    return <DXFormInput
      {...params}
      classes={classes}
      key={`${pid}.${question.id}`}
      valueState={valueState}
      onChange={question.readOnly ? null : this.props.onChange}
    />
  }

  renderDate = (params) => {
    const { valueState, classes } = this.props;
    const { setFormValueState } = this.props;

    return <DXFormInputDate
      {...params}
      classes={classes}
      key={`${params.pid}${params.question.id}`}
      valueState={valueState}
      setFormValueState={setFormValueState}
      onChange={this.props.onChange}
    />
  }

  renderSelection = (params) => {
    const { valueState, classes } = this.props;

    return <DXFormInputSelection
      key={`${params.pid}${params.question.id}`}
      {...params}
      classes={classes}
      valueState={valueState}
      setFormValueState={this.props.setFormValueState}
    />
  }

  renderCheckbox = (params) => {
    const { valueState, classes } = this.props;

    return <DXFormInputCheckbox
      {...params}
      classes={classes}
      key={`${params.pid}${params.question.id}`}
      valueState={valueState}
      setFormValueState={this.props.setFormValueState}
    />
  }

  renderLikert = (params) => {
    const { valueState, classes } = this.props;

    return <DXFormInputLikert
      {...params}
      classes={classes}
      key={`${params.pid}${params.question.id}`}
      valueState={valueState}
      setFormValueState={this.props.setFormValueState}
    />
  }

  renderFileUploader = (params) => {
    const { valueState, classes } = this.props;

    return <DXFormFileUploader
      {...params}
      classes={classes}
      key={`${params.pid}${params.question.id}`}
      valueState={valueState}
      setFormValueState={this.props.setFormValueState}
    />
  }

  renderSum = (pid, questions) => {
    if (questions.length === 0) {
      return null;
    } else {
      const { valueState } = this.props;
      let total = 0;
      let sum = 0;

      questions.forEach(question => {
        total += _.maxBy(question.options, 'value')['value'];
        const id = `${pid}.${question.id}`;
        sum += parseInt(_.get(valueState, id)) | 0;
      });
      return <span> ({sum} / {total})</span>
    }
  }

  onClickInfo = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleClose = () => {
    this.setState({ anchorEl: null });
  }


  render() {
    const { pid, section, classes } = this.props;
    const { title, questions = [], tip = null, sections, showSum = false, titleStyle = { sm: 2 } } = section;
    const { sm } = titleStyle;
    const id = pid ? `${pid}.${section.id}` : section.id;
    const { anchorEl } = this.state;

    return <GridContainer key={id} justify='center'>
      <GridItem xs={12} sm={12} md={12} className={classes.gridItem}>
        <Card className={classes.card}>
          <CardHeader color="rose" text>
            <CardText color="rose" className={classes.cardText}>
              <h4 className={classes.cardTitle}>
                {title}{showSum ? this.renderSum(id, questions) : null}
              </h4>
            </CardText>
            {
              tip
                ? <div className={classes.infoIcon}>
                  <Icon color={"disabled"} onClick={this.onClickInfo}>info</Icon>
                  <Popover
                    id={id}
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={this.handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                  >
                    <div className={classes.tipArea}>{tip.split('\n').map((txt, idx) => <div key={idx}>{txt}</div>)}</div>
                  </Popover>
                </div>

                : null
            }
          </CardHeader>
          <CardBody>
            {
              sections
                ? sections.map((section, index) => <DXFormSection
                  key={`${index}${id}`}
                  section={section}
                  pid={id}
                  valueState={this.props.valueState}
                  onChange={null}
                  setFormValueState={null}
                  classes={classes}
                />)
                : questions.map(question => this.renderQuestion(id, question))
            }

          </CardBody>
        </Card>
      </GridItem>

    </GridContainer >
  }
}
